<template>
  <div class="flex flex-col items-start">
    <BaseInput
      :id="id"
      :model-value="value"
      class="input"
      autocomplete="off"
      :aria-label="props.label"
      :disabled="props.disabled"
      :name="props.name"
      :mask="props.mask"
      :placeholder="fieldPlaceholder"
      :required="props.required"
      :type="props.type"
      @update:model-value="onUpdate"
      @blur="handleBlur($event, true)"
    />
    <InputError :error="errorMessage" />
  </div>
</template>

<script setup lang="ts">
import type { BaseInputProps } from '@/components/base/input/types'
import type { InputProps } from './types'

interface InputTextProps extends BaseInputProps, InputProps {
  type?: 'email' | 'text'
}

const props = withDefaults(defineProps<InputTextProps>(), { type: 'text' })
const { id, value, errorMessage, handleBlur, handleChange } = useInput<string>(
  props.name,
)

// The label now lives inside the field as its placeholder, so fall back to the
// label (with an "(optional)" hint) when no explicit placeholder is given.
const fieldPlaceholder = computed(
  () =>
    props.placeholder ??
    (props.label
      ? `${props.label}${props.required ? '' : ' (optional)'}`
      : undefined),
)

// Bind through BaseInput's model (not :value) so a prefilled/reset value is
// displayed. Preserve the "validate live only after an error exists" behaviour.
const onUpdate = (next: string | number | undefined) => {
  handleChange(next ?? '', Boolean(errorMessage.value))
}
</script>
